import React from 'react';
import './TreatmentImage.css'
import exampleImage from '../../images/doctor.PNG'; // Import your image here

const TreatmentImage = () => {
  return (
    <div className="treatments-image-section">
      <img src={exampleImage} alt="Example Image" className='treatments-image' />
      
    </div>
  );
};

export default TreatmentImage;
